export default {
  postDetail_reply_time:'按回復時間',
  postDetail_comment_time:'按評論時間',
  postDetail_undercarriage_tip1:'下架後，可在「我的帖子-我管理的評論和回復」中找到該內容，並恢復上架，確定要下架嗎？',
  postDetail_cancel_reply:'取消優質回帖',
  postDetail_set_reply:'設為優質回帖',
  postDetail_enter_commments:'請輸入評論',
  postDetail_limit_comment:'評論字數限製1000字',
  postDetail_related_resources:'相關資源',
  postDetail_had_click:'您已@該人員',
  postDetail_undercarriage_tip2:'下架後，可在「我的帖子-我管理的帖子」中找到該內容，並恢復上架，確定要下架嗎？'
}
